/**
 * Rascunhos do compositor, UM POR MODO (spec 018, US3 AS2): abrir Detalhes,
 * trocar de modo ou sair e voltar não apaga o que foi escrito. Vivem no
 * sessionStorage da aba — conveniência da pessoa, não dado do atendimento.
 */
import { useCallback, useEffect, useState } from 'react';

export type ComposerMode = 'reply' | 'note';

export interface Drafts {
  reply: string;
  note: string;
}

const EMPTY: Drafts = { reply: '', note: '' };

function read(key: string): Drafts {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return EMPTY;
    const parsed = JSON.parse(raw) as Partial<Drafts>;
    return {
      reply: typeof parsed.reply === 'string' ? parsed.reply : '',
      note: typeof parsed.note === 'string' ? parsed.note : '',
    };
  } catch {
    return EMPTY;
  }
}

function write(key: string, drafts: Drafts): void {
  try {
    if (!drafts.reply && !drafts.note) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, JSON.stringify(drafts));
  } catch {
    /* armazenamento bloqueado: o rascunho vive só na memória da tela */
  }
}

export function useDrafts(key: string) {
  const [drafts, setDrafts] = useState<Drafts>(() => read(key));
  // outro atendimento/conversa na mesma tela montada: rascunhos dele
  useEffect(() => setDrafts(read(key)), [key]);
  useEffect(() => write(key, drafts), [key, drafts]);
  const set = useCallback((mode: ComposerMode, text: string) => setDrafts((d) => ({ ...d, [mode]: text })), []);
  const clear = useCallback((mode: ComposerMode) => setDrafts((d) => ({ ...d, [mode]: '' })), []);
  const pending = drafts.reply.trim() !== '' || drafts.note.trim() !== '';
  return { drafts, set, clear, pending };
}
